/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Admin_Allocation_Form_Cancellation_Date_WarningInputs */

const en_admin_allocation_form_cancellation_date_warning = /** @type {(inputs: Admin_Allocation_Form_Cancellation_Date_WarningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Membership ends ${i?.date}`)
};

const de_admin_allocation_form_cancellation_date_warning = /** @type {(inputs: Admin_Allocation_Form_Cancellation_Date_WarningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mitgliedschaft endet am ${i?.date}`)
};

const es_admin_allocation_form_cancellation_date_warning = /** @type {(inputs: Admin_Allocation_Form_Cancellation_Date_WarningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La suscripción finaliza el ${i?.date}`)
};

const fr_admin_allocation_form_cancellation_date_warning = /** @type {(inputs: Admin_Allocation_Form_Cancellation_Date_WarningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`L'abonnement se termine le ${i?.date}`)
};

const nl_admin_allocation_form_cancellation_date_warning = /** @type {(inputs: Admin_Allocation_Form_Cancellation_Date_WarningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lidmaatschap eindigt op ${i?.date}`)
};

/** @type {(inputs: Admin_Allocation_Form_Cancellation_Date_WarningInputs) => LocalizedString} */
const it_admin_allocation_form_cancellation_date_warning = en_admin_allocation_form_cancellation_date_warning;

/** @type {(inputs: Admin_Allocation_Form_Cancellation_Date_WarningInputs) => LocalizedString} */
const pt_br2_admin_allocation_form_cancellation_date_warning = en_admin_allocation_form_cancellation_date_warning;

/** @type {(inputs: Admin_Allocation_Form_Cancellation_Date_WarningInputs) => LocalizedString} */
const pl_admin_allocation_form_cancellation_date_warning = en_admin_allocation_form_cancellation_date_warning;

/** @type {(inputs: Admin_Allocation_Form_Cancellation_Date_WarningInputs) => LocalizedString} */
const hu_admin_allocation_form_cancellation_date_warning = en_admin_allocation_form_cancellation_date_warning;

/** @type {(inputs: Admin_Allocation_Form_Cancellation_Date_WarningInputs) => LocalizedString} */
const ro_admin_allocation_form_cancellation_date_warning = en_admin_allocation_form_cancellation_date_warning;

/**
* | output |
* | --- |
* | "Membership ends {date}" |
*
* @param {Admin_Allocation_Form_Cancellation_Date_WarningInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_allocation_form_cancellation_date_warning = /** @type {((inputs: Admin_Allocation_Form_Cancellation_Date_WarningInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Allocation_Form_Cancellation_Date_WarningInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_allocation_form_cancellation_date_warning(inputs)
	if (locale === "de") return de_admin_allocation_form_cancellation_date_warning(inputs)
	if (locale === "es") return es_admin_allocation_form_cancellation_date_warning(inputs)
	if (locale === "fr") return fr_admin_allocation_form_cancellation_date_warning(inputs)
	if (locale === "nl") return nl_admin_allocation_form_cancellation_date_warning(inputs)
	if (locale === "it") return it_admin_allocation_form_cancellation_date_warning(inputs)
	if (locale === "pt-BR") return pt_br2_admin_allocation_form_cancellation_date_warning(inputs)
	if (locale === "pl") return pl_admin_allocation_form_cancellation_date_warning(inputs)
	if (locale === "hu") return hu_admin_allocation_form_cancellation_date_warning(inputs)
	return ro_admin_allocation_form_cancellation_date_warning(inputs)
});
export { admin_allocation_form_cancellation_date_warning as "admin.allocation_form.cancellation_date_warning" }